import React, { useState } from 'react'
import { IconButton, Box, Button, MenuItem, Grid, FormControl, TextField, Icon } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import CloseIcon from '@material-ui/icons/Close'
import RemoveIcon from '@material-ui/icons/Remove'
import SettingsIcon from '@material-ui/icons/Settings'
import { useStyles } from './style'
import { useFormikContext, Formik, FieldArray, Form, getIn } from 'formik'
import * as yup from 'yup'
import CustomDialog from '../../Components/CustomDialog'
import TableColumns from './TableColumns'
import _ from 'lodash'
import { STATE, CITY, ZIP, STATUS, ALL } from './constant'

const Values = (props) => {
  const { values } = useFormikContext()
  props.setShowClear(!_(props.filters).differenceWith(props.initialFilters, _.isEqual).isEmpty())
  return null
}

const validationSchema = yup.object().shape({
  filters: yup.array().of(
    yup.object().shape({
      filter: yup.string()
        .required('Select Filter'),
      value: yup.string()
        .required('Value is required')
    })
  )
})

function Filters(props) {
  const classes = useStyles()
  const [showFilters, setShowFilters] = useState(false)
  const [selectModal, setSelectModal] = useState(false)
  const [filters, setFilters] = useState([
    {
      filter: '',
      value: ''
    }
  ])
  const [showClear, setShowClear] = useState(false)
  const initialFilters = [
    {
      filter: '',
      value: ''
    }
  ]

  const clearFilters = () => {
    setFilters(initialFilters)
    setShowClear(false)
    props.handleFilters({})
  }

  const handleShowFilters = () => {
    setShowFilters(!showFilters)
  }

  return (
    <>
      <Box className={classes.filterWrapper}>
        <CustomDialog open={selectModal} fullWidth maxWidth="md" title={'Select Columns'} content={<TableColumns columns={props.columns} handleClose={() => setSelectModal(false)} handleRows={props.handleRows} headings={props.headings} resetDefault={props.resetDefault} />} handleClose={() => setSelectModal(false)} />
        <Box className={classes.headingWrapper} display="flex" flexWrap="wrap">
          <Box flexGrow={1}>
            <span>Filter Data</span>
            <IconButton onClick={handleShowFilters}>
              {showFilters ? <RemoveIcon className={classes.filterIcon} /> : <AddIcon className={classes.filterIcon} />}
            </IconButton>
            {!showFilters && showClear &&
              <Button
                className={`${classes.filterIcon} ${classes.clearFilter}`}
                disableRipple
                disableFocusRipple
                disableElevation
                variant="contained"
                color="primary"
                endIcon={<CloseIcon />}
                onClick={() => { clearFilters() }}
              >
                Clear Filters
              </Button>
            }
          </Box>
          <Box>
            {showFilters ? '' :
              <IconButton onClick={() => setSelectModal(true)}>
                <SettingsIcon className={classes.filterIcon} />
              </IconButton>
            }
          </Box>
        </Box>
        {showFilters ?
          <>
            <Formik
              initialValues={{
                filters:
                  filters
              }}
              validationSchema={validationSchema}
              onSubmit={values => {
                setFilters(values.filters)
                let tags = {}
                values.filters.forEach((filter) => {
                  tags[filter.filter] = filter.value.split(',').map(item => item.trim())
                })
                props.handleFilters(tags)
              }}
            >
              {({ values, touched, errors, handleChange, setFieldValue }) => (
                <Form noValidate >
                  <>
                    <Box display="flex" flexWrap="wrap" >
                      <FieldArray name="filters">
                        {({ insert, remove }) => (
                          values.filters.map((count, index) => (
                            <Box display="flex" flexWrap="wrap" flexGrow="1">
                              <FormControl className={classes.formControl}>
                                <TextField
                                  id={`filters.${index}.filter`}
                                  select
                                  label="Filter"
                                  name={`filters.${index}.filter`}
                                  value={count.filter}
                                  onChange={(e) => {
                                    setFieldValue(`filters.${index}.value`, '')
                                    handleChange(e)
                                  }}
                                  InputProps={{
                                    classes: { root: classes.input }
                                  }}
                                  SelectProps={{
                                    MenuProps: {
                                      classes: { paper: classes.paper },
                                      anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left"
                                      },
                                      getContentAnchorEl: null
                                    }
                                  }}
                                  error={getIn(touched, `filters.${index}.filter`) && Boolean(getIn(errors, `filters.${index}.filter`))}
                                  helperText={getIn(touched, `filters.${index}.filter`) && getIn(errors, `filters.${index}.filter`)}
                                >
                                  <MenuItem disabled={values.filters.some(el => el.filter === STATE)} value={STATE}>State</MenuItem>
                                  <MenuItem disabled={values.filters.some(el => el.filter === CITY)} value={CITY}>City</MenuItem>
                                  <MenuItem disabled={values.filters.some(el => el.filter === STATUS)} value={STATUS}>Status</MenuItem>
                                  <MenuItem disabled={values.filters.some(el => el.filter === ZIP)} value={ZIP}>Zip/Postal Code</MenuItem>
                                </TextField>
                              </FormControl>
                              <Box m={2} pt={2} className={classes.betweenFilterText}>Is</Box>
                              <FormControl className={classes.formControl}>
                                {count.filter === STATUS ?
                                  <TextField
                                    fullWidth
                                    select
                                    id={`filters.${index}.value`}
                                    name={`filters.${index}.value`}
                                    label="value"
                                    value={count.value}
                                    onChange={handleChange}
                                    InputProps={{
                                      classes: { root: classes.input }
                                    }}
                                    SelectProps={{
                                      MenuProps: {
                                        anchorOrigin: {
                                          vertical: "bottom",
                                          horizontal: "left"
                                        },
                                        getContentAnchorEl: null
                                      }
                                    }}
                                    error={getIn(touched, `filters.${index}.value`) && Boolean(getIn(errors, `filters.${index}.value`))}
                                    helperText={getIn(touched, `filters.${index}.value`) && getIn(errors, `filters.${index}.value`)}
                                  >
                                    {/* <MenuItem value={'APPLICATION_STARTED'}>Application Started</MenuItem>
                                    <MenuItem value={'APPLICATION_SUBMITTED'}>Application Submitted</MenuItem>
                                    <MenuItem value={'APPLICATION_REJECTED'}>Application Rejected</MenuItem> */}
                                    <MenuItem value={'ENROLLED'}>Enrolled</MenuItem>
                                    <MenuItem value={'UNENROLLED'}>Unenrolled</MenuItem>
                                  </TextField> :
                                  <TextField
                                    fullWidth
                                    id={`filters.${index}.value`}
                                    name={`filters.${index}.value`}
                                    label="value"
                                    value={count.value}
                                    onChange={handleChange}
                                    onInput={(e) => {
                                      if (count.filter === ZIP) {
                                        e.target.value = e.target.value.toString().replace(/[,]/g, '').slice(0, 20)
                                      }
                                    }}
                                    onBlur={(e) => setFieldValue(`filters.${index}.value`, e.target.value.trim())}
                                    error={getIn(touched, `filters.${index}.value`) && Boolean(getIn(errors, `filters.${index}.value`))}
                                    helperText={(getIn(touched, `filters.${index}.value`) && getIn(errors, `filters.${index}.value`)) || (count.filter === STATE && ' * Enter valid state code')}
                                  />
                                }
                              </FormControl>
                              <Box display="flex" flexWrap="wrap">
                                {
                                  values.filters.length < 4 ?
                                    <IconButton className={classes.formIcon} onClick={() =>
                                      insert(index + 1, { filter: "", value: "" })
                                    }>
                                      <AddIcon className={classes.filterIcon} />
                                    </IconButton> : ''
                                }
                                {
                                  values.filters.length > 1 ?
                                    <IconButton className={classes.formIcon} onClick={() => remove(index)}>
                                      <RemoveIcon className={classes.filterIcon} />
                                    </IconButton> : ''
                                }
                              </Box>
                            </Box>
                          )))}
                      </FieldArray>
                      <Values setShowClear={setShowClear} initialFilters={initialFilters} filters={filters} />
                    </Box>
                    <Button type="submit" variant="outlined" color="primary">Filter Results</Button>
                  </>
                </Form>
              )}
            </Formik>
          </> : ''}
      </Box>
    </>
  )
}

export default Filters